export {
    AUDIOBOOK_VOICES,
    AUDIOBOOK_VOICE_NAME_MAP,
    CUSTOM_MODEL_VOICES,
    ELEVENLABS_VOICES,
    SPECIAL_VOICES,
} from "../../Data/audiobookVoices.js";

export const AUDIOBOOK_WORK_TYPES = [
    { id: "performancedirection", name: "Performance Direction" },
    { id: "finalqa", name: "Final QA Review" },
];

export const AUDIOBOOK_MERGE_NOTIFICATION_EMAILS = process.env.REACT_APP_NOTIFICATION_EMAILS
    ? process.env.REACT_APP_NOTIFICATION_EMAILS.split(",").map((e) => e.trim()).filter(Boolean)
    : [];
